<template>
  <div class="history" :class="{ 'mobile': isMobile, 'visible': isVisible }">
    <div v-if="isMobile" class="mobile-toggle" @click="toggleVisibility">
      <a-icon :type="isVisible ? 'menu-fold' : 'menu-unfold'" />
    </div>
    
    <div class="history-content">
      <div class="new-chat-button-container">
        <button class="new-chat-button" @click="$emit('newChat')">
          <svg class="chat-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 15C21 15.5523 20.5523 16 20 16H8L4 20V4C4 3.44772 4.44772 3 5 3H16C16.5523 3 17 3.44772 17 4V12H20C20.5523 12 21 12.4477 21 13V15ZM19 14V13H17V4H5V18L8 15H20C20.5523 15 21 15.4477 21 16V18H19V16H8L5 19V4H16V12H19V14Z" fill="currentColor"/>
            <path d="M12 9H9V12H12V9Z" fill="currentColor"/>
            <path d="M15 9H12V12H15V9Z" fill="currentColor"/>
          </svg>
          开启新对话
        </button>
      </div>

      <div class="history-section">
        <div class="history-group">
          <div class="group-title">最近对话</div>
          <ul>
            <!-- <li class="history-item active">婴儿长牙时间及护理指南</li> -->
            <li class="history-item" @click="view(item)" v-for="item in dataList" :key="item.id">{{ item.name }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAiAppList, updateAIChatHistory, deleteAIChatHistory } from '@/api/aiApp.js'

export default {
  data() {
    return {
      dataList: [],
      isMobile: false,
      isVisible: false
    }
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async getList() {
      const res = await getAiAppList({
          last_id: '',
          sort_by: this.sortBy,
          limit: 20
        },
        {
          'X-App-Id': '4b9113f8-1ccb-4429-bf4e-154ec7dcbade'
        })
      this.dataList = res.data
    },
    view(record) {
      // this.$router.push({
      //   name: 'aiChat',
      //   query: {
      //     id: '4b9113f8-1ccb-4429-bf4e-154ec7dcbade',
      //     conversationId: record.id
      //   }
      // })
      const id = '4b9113f8-1ccb-4429-bf4e-154ec7dcbade'
      window.location.href = `/ai/chat?id=${id}&conversationId=${record.id}`
    },
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
      // 在移动端默认隐藏侧边栏
      if (this.isMobile) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    }
  },
  mounted() {
    this.getList();
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  }
}
</script>

<style scoped lang="less">
.history {
  width: 260px;
  height: 100vh;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0;
  display: flex;
  flex-direction: column;
  padding: 20px 10px;
  box-sizing: border-box;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  transition: transform 0.3s ease;
  
  &.mobile {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    transform: translateX(-100%);
    background: #fff;
    
    &.visible {
      transform: translateX(0);
    }
  }
}

.mobile-toggle {
  position: absolute;
  top: 10px;
  right: -40px;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  
  .anticon {
    font-size: 18px;
    color: #ff3f1a;
  }
}

.history-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.new-chat-button-container {
  padding: 4px;
  margin-bottom: 6px;
}

.new-chat-button {
  width: 100%;
  padding:4px;
  background-color: #f7eee5;
  color: #ff3f1a;
  border: none;
  border-radius: 25px; /* 更大的圆角 */
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background-color: #faebdd;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
}

.chat-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  color: #FF9E3F;
}

.history-section {
  flex-grow: 1;
  overflow-y: auto;
}

.history-group {
  margin-bottom: 20px;
}

.group-title {
  font-size: 14px;
  color: #888;
  text-align: left;
  margin-bottom: 10px;
}

.history-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  margin-bottom: 8px;
  background-color: #fff;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: #f0f0f0;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  &.active {
    background-color: #e0e7ff; /* 选中状态的背景色 */
    color: #4a7dff; /* 选中状态的文字颜色 */
    font-weight: 500;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
}

.item-text {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-more {
  font-weight: bold;
  margin-left: 10px;
  color: #888;
}
</style>
